// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__v4s9D","withItems":"Cart_withItems__OH1AB","counter":"Cart_counter__k3u6h"};